module.exports = __webpack_public_path__ + "public/img/ico-schematics-pv-shadow.33c21227.svg";